import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import UsLicenses from "../components/UsLicenses.vue";
import PrivacyNotice from "../views/PrivacyNotice.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/usLicenses",
    name: "UsLicenses",
    component: UsLicenses,
  },
  {
    path: "/privacy-notice",
    name: "PrivacyNotice",
    component: PrivacyNotice,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
